enum TotalMetric {
  Impressions = 'Impressions',
  Reach = 'Reach',
  Frequency = 'Frequency',
  VCR = 'VCR',
  CTR = 'CTR',
  LTR = 'LTR',
  Spend = 'Spend',
  //#region offline sales
  TotalSales = 'Total Sales Upload',
  MatchedSales = 'Matched Sales',
  MatchedConversions = 'Matched Conversions',
  ExtrapolatedConversions = 'Extrapolated Conversions',
  MediaSalesPercent = '% of Sales Came From Media',
  UniqueCVR = 'Unique CVR',
  //#endregion
  //#region foot traffic
  FootTrafficVisits = 'Visits',
  FootTrafficLiftPercent = 'Lift %',
  VisitsConversionRate = 'Visits Conversion Rate',
  YoyPercentChange = 'YoY % Change',
  TwoYearBaselineChange = 'vs. 2-Year Baseline',
  AvgWeeklyUniqueVisitors = 'Avg Weekly Unique Visitors',
  //#endregion
  //#region esm
  CostPerClick = 'Cost Per Click (CPC)',
  CostPerImpression = 'Cost Per Impression (CPM)',
  CostPerConversion = 'Cost Per Conversion',
  EngagementRate = 'Engagement Rate',
  //#endregion
}

export default TotalMetric;
